import {GetAnalysisChart, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {
  DataMappingState,
  TargetSpecificMappingState,
} from 'analysis-tool/structured-data-mapping/DataMappingTypes';
import {SidebarItemData} from 'analysis-tool/ui/sidebar/SidebarItemDatas';
import {DataFrameDomainNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingDuotoneIconName} from 'ui-library/icons/BenchlingDuotoneIcon';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export enum AnalysisOutputType {
  CHART = 'CHART',
  DATASET = 'DATASET',
  RESULT = 'RESULT',
}
export interface BaseAnalysisOutputConfig {
  step: GetAnalysisPipelineStep;
  icon: BenchlingDuotoneIconName | BenchlingIconName;
  outputName: string;
  // if AnalysisOutput is nested, this is the name of the output that it is nested under
  parentOutputName: string | null;
}

export interface ChartOutputConfig extends BaseAnalysisOutputConfig {
  type: AnalysisOutputType.CHART;
  chart: GetAnalysisChart;
}

export interface DatasetOutputConfig extends BaseAnalysisOutputConfig {
  type: AnalysisOutputType.DATASET;
  dataFrame: DataFrameDomainNode;
}

/** @package */
export interface ResultOutputConfig extends BaseAnalysisOutputConfig {
  type: AnalysisOutputType.RESULT;
  dataFrame: DataFrameDomainNode;
  newDataMapping: DataMappingState;
  targetSpecificMappingState: TargetSpecificMappingState | null;
}
export type AnalysisOutputConfig = DatasetOutputConfig | ResultOutputConfig | ChartOutputConfig;

export type AnalysisOutputConfigWithoutResultsMapping =
  | ChartOutputConfig
  | DatasetOutputConfig
  | Omit<ResultOutputConfig, 'newDataMapping'>;

export interface AnalysisOutputOptionItem {
  indentLevel: number;
  sidebarItemData: Pick<SidebarItemData, 'icon' | 'title'>;
  selectorIndex: number;
  outputConfigs: Array<AnalysisOutputConfigWithoutResultsMapping>;
  disabledReason: string | null;
}

export type AnalysisOutput = Omit<AnalysisOutputOptionItem, 'outputConfigs'> & {
  outputConfig: AnalysisOutputConfig;
};

export enum OutputDocumentLayoutItemType {
  DOCUMENT_CONTENT = 'DOCUMENT_CONTENT',
  DOCUMENT_SECTION_TITLE = 'DOCUMENT_SECTION_TITLE',
}

export interface OutputDocumentContent {
  type: OutputDocumentLayoutItemType.DOCUMENT_CONTENT;
  icon: BenchlingDuotoneIconName | BenchlingIconName;
  outputConfig: AnalysisOutputConfig;
  selectorIndex: number;
}

export interface OutputDocumentSectionTitle {
  type: OutputDocumentLayoutItemType.DOCUMENT_SECTION_TITLE;
  title: string;
}

export type OutputDocumentLayoutItem = OutputDocumentContent | OutputDocumentSectionTitle;

export type OutputDocumentLayoutConfiguration = Array<OutputDocumentLayoutItem>;

export const OUTPUT_NAME_SEPARATOR = ' / ';
